<div class="irembogov-formcontrol-toggle-switch toggle {{ startMargin }}">
  <irembogov-basic-toggle-switch
    [startMargin]="startMargin"
    [text]="text"
    [uniqueId]="uniqueId"
    [labelTextClass]="labelTextClass"
    (switchChanged)="updateValue($event)"></irembogov-basic-toggle-switch>
</div>
